<script setup lang="ts">

</script>

<template>
<div/>
</template>

<style>
.font-nunito {
  font-family: "nunito-sans", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.font-nunito-italic {
  font-family: "nunito-sans", sans-serif;
  font-weight: 400;
  font-style: italic;
}

.font-nunito-bold {
  font-family: "nunito-sans", sans-serif;
  font-weight: 700;
  font-style: normal;
}

.font-minerva {
  font-family: "minerva-modern", sans-serif;
  font-weight: 300;
  font-style: normal;
}

.font-minerva-italic {
  font-family: "minerva-modern", sans-serif;
  font-weight: 200;
  font-style: italic;
}

#rubin-items-wrapper {
  font-family: "nunito-sans", sans-serif;
  font-weight: 400;
  font-style: normal;
}

#rubin-items-wrapper .title {
  font-family: "minerva-modern", sans-serif;
  font-weight: 200;
  font-style: italic;
}

</style>